export default "__VITE_ASSET__CIut4tQu__"